import FilterService from "Services/filter";

export const FILTERS_ALL_REQUESTED = "FILTERS_ALL_REQUESTED";
export const FILTERS_ALL_OK = "FILTERS_ALL_OK";
export const FILTERS_ALL_FAIL = "FILTERS_ALL_FAIL";

export function loadFiltersAll() {
  return (dispatch) => {
    dispatch({ type: FILTERS_ALL_REQUESTED, payload: { isLoading: true } });

    FilterService.loadFilters()
      .then((data) => {
        dispatch({
          type: FILTERS_ALL_OK,
          payload: { filters: data, isLoading: false },
        });
      })
      .catch((errors) => {
        dispatch({
          type: FILTERS_ALL_FAIL,
          payload: { errors: errors, isLoading: false },
        });
      });
  };
}
